<template>
  <div class="tablelist">
    <div class="row align--center">
      <div class="flex xs12 md2">
        <va-input :value="term2" placeholder="Id Banner" @input="search2">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 md2">
        <va-input :value="term" placeholder="Numero de Documento" @input="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 md4">
        <va-input :value="term3" placeholder="Nombre Estudiante" @input="search3">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 md2 offset--md2">
        <va-select v-model="perPage" :label="$t('tables.perPage')" :options="perPageOptions" />
      </div>
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda"
    >
    <div>
    </div>
      <template slot="staActive" slot-scope="props">
        <img class="imgdata ma-0" src="../../assets/images/user_check.png" width="20" title="Activo" v-if="props.rowData.staActive === true"/>
        <img class="imgdata ma-0" src="../../assets/images/user_inactive.png" width="20" title="Inactivo" v-else/>
      </template>
      <template slot="actions" slot-scope="props">
        <div v-for="item of fields[fields.length-1].actionRef" :key="item.id">
          <template v-if="item.action === 'edit'">
            <img class="imgdata ma-0" :id="props.rowData.Id_Grade" src="../../assets/images/edit.png" alt="Editar Grado" title="Editar Grado" width="20"  @click="dataGrade(props.rowData, item.action)"/>
          </template>
        </div>
      </template>
    </va-data-table>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  data () {
    return {
      term: null,
      term2: null,
      term3: null,
      perPage: '20',
      perPageOptions: ['5', '10', '15', '20'],
      staActiveModel: '',
      Grade: this.InfoView,
    }
  },
  props: {
    method: Function,
    InfoView: Array,
    HeadTable: Array,
  },
  computed: {
    fields () {
      return this.HeadTable
    },
    filteredData () {
      debugger
      if (this.term) {
        return this.Grade.filter(item => {
          if (this.term && this.term.length >= 1) {
            return item.Numero_Identificacion.includes(this.term)
          }
        })
      } else if (this.term2) {
        return this.Grade.filter(item => {
          if (this.term2 && this.term2.length >= 1) {
            return item.Id_Banner.includes(this.term2)
          }
        })
      } else if (this.term3) {
        return this.Grade.filter(item => {
          if (this.term3 && this.term3.length >= 1) {
            return item.Nombres.toLowerCase().includes(this.term3)
          }
        })
      } else if (((!this.term) || (!this.term2))) {
        return this.Grade
      }
    },
  },
  methods: {
    dataGrade (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
    search2: debounce(function (term2) {
      this.term2 = term2
    }, 400),
    search3: debounce(function (term3) {
      this.term3 = term3
    }, 400),
  },
}
</script>

<style>
.tablelist .va-button {
  color: #a2273c !important;
  border-color: #a2273c !important;
}

.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #a2273c !important;
  background-color: #a2273c !important;
}

.tablelist .va-select__label {
  color: #a2273c !important;
}
.va-select__option--selected {
  color: #a2273c !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #ffffff !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #a2273c !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #a2273c !important;
}

.imgdata{
  cursor: pointer;
  margin-left: 2px !important;
  margin-right: 2px !important;
}
</style>
